import type { ComponentChildren } from 'preact';

/** A link the client router must not intercept (it points at a static page or the API). */
export function NativeLink({ href, children, class: cls }: { href: string; children: ComponentChildren; class?: string }) {
  return <a href={href} class={cls} {...({ native: '' } as Record<string, string>)}>{children}</a>;
}
